module.exports = __webpack_public_path__ + "static/san-francisco-golden-gate-bridge-b30f1f8b0738ab462d5f31945322d18b.png";